/* ============================================================
   Véloria Piercing — Animations globales
   Scroll reveal · Stagger · Parallax léger
   ============================================================ */

(function () {
  'use strict';

  /* ── 1. SCROLL REVEAL ───────────────────────────────────── */
  const revealCSS = `
    .v-reveal {
      opacity: 0;
      transform: translateY(28px);
      transition: opacity 0.65s cubic-bezier(0.22,1,0.36,1),
                  transform 0.65s cubic-bezier(0.22,1,0.36,1);
    }
    .v-reveal.is-visible {
      opacity: 1;
      transform: translateY(0);
    }
    .v-reveal--left  { transform: translateX(-32px); }
    .v-reveal--right { transform: translateX(32px); }
    .v-reveal--left.is-visible,
    .v-reveal--right.is-visible { transform: translateX(0); }
    .v-reveal--scale {
      transform: scale(0.94);
      opacity: 0;
    }
    .v-reveal--scale.is-visible {
      transform: scale(1);
      opacity: 1;
    }
  `;

  const styleEl = document.createElement('style');
  styleEl.textContent = revealCSS;
  document.head.appendChild(styleEl);

  /* Éléments à animer automatiquement */
  const AUTO_TARGETS = [
    { selector: '.v-section-header',    cls: 'v-reveal',         delay: 0   },
    { selector: '.v-zones__card',       cls: 'v-reveal--scale',  stagger: 80 },
    { selector: '.v-product-card',      cls: 'v-reveal',         stagger: 60 },
    { selector: '.v-lookbook__card',    cls: 'v-reveal--scale',  stagger: 90 },
    { selector: '.v-guide__card',       cls: 'v-reveal',         stagger: 70 },
    { selector: '.v-avis__card',        cls: 'v-reveal',         stagger: 80 },
    { selector: '.v-reassurance__item', cls: 'v-reveal',         stagger: 60 },
    { selector: '.v-hero__text',        cls: 'v-reveal--left',   delay: 0   },
    { selector: '.v-hero__visual',      cls: 'v-reveal--right',  delay: 120 },
    { selector: '.v-marque__visual',    cls: 'v-reveal--left',   delay: 0   },
    { selector: '.v-marque__text',      cls: 'v-reveal--right',  delay: 100 },
    { selector: '.v-newsletter__inner', cls: 'v-reveal',         delay: 0   },
    { selector: '.v-earstack__header',  cls: 'v-reveal',         delay: 0   },
  ];

  function applyRevealClasses() {
    AUTO_TARGETS.forEach(function (t) {
      document.querySelectorAll(t.selector).forEach(function (el, i) {
        el.classList.add('v-reveal');
        if (t.cls !== 'v-reveal') el.classList.add(t.cls);
        const d = t.stagger ? i * t.stagger : (t.delay || 0);
        el.style.transitionDelay = d + 'ms';
      });
    });
  }

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  function observeRevealElements() {
    document.querySelectorAll('.v-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── 2. PARALLAX LÉGER SUR LES IMAGES HERO ─────────────── */
  function initParallax() {
    const heroCard = document.querySelector('.v-hero__card');
    if (!heroCard || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          const scrollY = window.scrollY;
          const img = heroCard.querySelector('img');
          if (img) img.style.transform = 'translateY(' + (scrollY * 0.06) + 'px)';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── 3. COMPTEUR ANIMÉ (note avis) ─────────────────────── */
  function animateCounters() {
    document.querySelectorAll('.v-avis__aggregate-score').forEach(function (el) {
      const target = parseFloat(el.textContent);
      if (isNaN(target)) return;
      const duration = 1200;
      const start = performance.now();
      const startVal = target - 0.4;

      const counterObs = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        counterObs.unobserve(el);

        function step(now) {
          const elapsed = now - start;
          const progress = Math.min(elapsed / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = (startVal + eased * 0.4).toFixed(1);
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }, { threshold: 0.5 });

      counterObs.observe(el);
    });
  }

  /* ── 4. HOVER MAGNÉTIQUE SUR LES BOUTONS CTA ───────────── */
  function initMagneticButtons() {
    if (window.matchMedia('(hover: none)').matches) return;

    document.querySelectorAll('.v-btn--primary').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        const rect = this.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        this.style.transform = 'translate(' + (x * 0.18) + 'px, ' + (y * 0.25 - 1) + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        this.style.transform = '';
      });
    });
  }

  /* ── 5. SHIMMER SUR LES IMAGES EN CHARGEMENT ───────────── */
  const shimmerCSS = `
    .v-product-card__img img,
    .v-zones__card-img img,
    .v-lookbook__card-img img {
      background: linear-gradient(90deg, #F1E4DE 25%, #FAF7F2 50%, #F1E4DE 75%);
      background-size: 200% 100%;
    }
    .v-product-card__img img:not([src]),
    .v-zones__card-img img:not([src]) {
      animation: v-shimmer 1.5s infinite;
    }
    @keyframes v-shimmer {
      0%   { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }
  `;
  const shimmerStyle = document.createElement('style');
  shimmerStyle.textContent = shimmerCSS;
  document.head.appendChild(shimmerStyle);

  /* ── 6. SMOOTH SCROLL POUR LES LIENS D'ANCRE ───────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ── INIT ───────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    applyRevealClasses();
    observeRevealElements();
    initParallax();
    animateCounters();
    setTimeout(initMagneticButtons, 500);
  }

})();
